/* 
 * React component to show a week template. 
 * Using fullCallendar component; see https://fullcalendar.io/docs#toc
 * This is similare to editing 
 */

import React, {useState, useRef}     
                                        from 'react'

import FullCalendar                     from '@fullcalendar/react'
import resourceTimeGridPlugin           from '@fullcalendar/resource-timegrid'
import resourceDayGridPlugin            from '@fullcalendar/resource-daygrid'
import interactionPlugin                from '@fullcalendar/interaction'

import {getTimeStr, TimePeriod}         from '../../lib/iprs-react-library/src/index.js';

import TemplateCalendarOverlay          from './TemplateCalendarOverlay'
import {teamDayStartTime}               from '../Util/earlyStart'

/* This is the license key which allows use of paid for views of the calendar.
 * See env.local and .env files. */
const schedulerLicenseKey =  process.env.REACT_APP_SCHEDULER_LICENSE_KEY

const TemplateCalendar = ({api, state}) => {
    
    const {template: {templateID, templates = []},
          team: { teamID = 0 } = {},
          appType: { appointmentTypes = [] } = {} }                      = state

    /* Templates are not held against a team, so the template calendar follows
     * the team currently selected in the side bar. */
    const dayStartTime = teamDayStartTime(teamID);

    // Find the current template name
    const currentTemplate = templates.find(t => t.id === templateID);
    const templateName = currentTemplate ? currentTemplate.Name : ''; 
    
    /* the overlay is for editing things. It shows over the top of the calendar
     * The showOverlay object contains the details of the event the overlay edits
     */
    const [showOverlay, setShowOverlay]    = useState(null)
    
    //const [events,      setEvents]         = useState([])
   
    
    /* Similarly to the above overlay, this is an ID. If this is set then
     * a confirm overlay shows*/
    //const [deleteTemplateEntryID, setDeleteTemplateEntryID]  = useState(0)
    
    // used to filter which people are displayed
    // const [teamFilter, setTeamFilter]      = useState([]) 
    
    const calendarRef = useRef();
    
    const doRender  = () => {
        
        calendarRef.current.getApi().refetchEvents();
    }
    
    /* Called by the calendar when the user selects a region of the calendar; 
     * this selects calendar time not a particular event. */
    const handleSelectRegion = (info) => {
        setShowOverlay({event: info, templateID})
    }
    
    /* Handles a click on an event. Currently we just delete the event with no
     * confirmation step */
    const handleClick = eventInfo => {
        
        setShowOverlay({event: eventInfo.event, templateID})
    }
    
    /* Called by the calendar when the user resizes an event; i.e when they drag 
     * the start or end of the event */
    const handleResize = eventResizeInfo => {
        
        const oldEvent =  eventResizeInfo.oldEvent
        const event    =  eventResizeInfo.event
        
        const { 
            pkRotaWeekTemplateEntryID:  id,
            fkRotaWeekTemplateID:       templateID,
            fkRotaTypeID:               rotaTypeID,
            DayOfWeek:                  dayOfWeek,
            RowVersion:                 rowVersion
        }                               = oldEvent.extendedProps.apiEvent
        const {start, end}              = event
     
        const startTime = getTimeStr( start )
        const endTime   = getTimeStr( end )
        
        api.updateRotaTemplateEntry(
            id, 
            templateID, 
            startTime, 
            endTime, 
            dayOfWeek, 
            rotaTypeID,
            rowVersion
        )
        .then( response => {
            /* hack to get REACT to re-render */
            doRender()
        })
        .catch(e => {
            doRender()
        })
    }
    
    /* Called by the calendar component to render an individual event */
    const eventContent = (ev) => {
        
        const evAPISrc = ev.event.extendedProps.hasOwnProperty('apiEvent')?
        ev.event.extendedProps.apiEvent: {}; 
        
        const {RotaTypeID: rotaTypeID, BookingID: bookingID,
        CaseID: caseID = 0, Name: patientName = ''} = evAPISrc

        // Console.log() is used to use the unused value for linter.
        console.log(rotaTypeID, bookingID, caseID);
                
        const title = ev.event.title + (patientName? ' (' + patientName + ')': '')
        return (
            <div>
                <b>{ev.timeText}</b>
                <h1 style={{fontSize: '1rem', color: 'white'}} >{title}</h1>
            </div>   
        )
    }
    
    const eventDrop = (info) => {
        
        console.log(info)
        
        const {
            event: {
                extendedProps: {
                    apiEvent: {
                        pkRotaWeekTemplateEntryID:  id,
                        fkRotaWeekTemplateID:       templateID,
                        fkRotaTypeID:               rotaTypeID,
                        RowVersion:                 rowVersion,
                        // This property is not currently being used and it is commented out for linting.
                        // selectedAppTypes
                    }
                },
                start,
                end
            },
            oldEvent: {
                end: oldEnd, start: oldStart
            }
        }  = info
     
        const dayOfWeek = start.getDay()
        
        const oldTimes = new TimePeriod( oldStart, oldEnd );
        const newTimes = new TimePeriod( start,    end );
        
        /* whether we move or copy, we always move the thing being dropped. */
        let saveUpdate = api.updateRotaTemplateEntry(
                id, 
                templateID, 
                getTimeStr( start ), 
                getTimeStr( end ), 
                dayOfWeek, 
                rotaTypeID,
                rowVersion
            );

        const oldDayOfWeek = oldStart.getDay();
        /* As we are copying, we lookup the app types on the thing just dropped
         * and then create a new object and attach the types.*/
        let appTypes = null;
        if (!newTimes.overlaps(oldTimes)){
        saveUpdate = saveUpdate.then( r => api.getRotaWeekTemplateEntryAppointmentTypeList(id) )
            .then( r => r.apiResult )
            .then( r => { appTypes = r.map( r => r.pkAppointmentTypeID ); return r; }  )
            .then( r => api.createRotaTemplateEntry(templateID, getTimeStr( oldStart ), getTimeStr( oldEnd ), 
                oldDayOfWeek, rotaTypeID) )
            .then( r => r.apiResult.RotaWeekTemplateEntryID ) // pass on the new entry ID
            .then( r => api.SaveRotaWeekTemplateEntryAppointmentType( r, appTypes ) );
        }
        
        saveUpdate.then( response => {
            /* hack to get REACT to re-render */
            doRender();
        })
        .catch(e => {
            doRender();
        });
    }
    
    const eventSource = (info, successCallback, failureCallback) => {
        
        if(!templateID){
            failureCallback("Template not selected")
        }else{
            
            api.getRotaTypeList()
                .then(response => {
                    const rotaTypes = response.apiResult
                    return api.getRotaTemplate( templateID )
                        .then( response => response.apiResult )
                        .then( apiResult => apiResult.Template )
                        .then( template => { 

                        /* We receive an array of event data. As these are template 
                         * events, that have a time of day and day number, we convert
                         * to real dates that the calendar can display. We choose an 
                         * arbitary week beginning 5 Jan 1970 which is the first Monday
                         * after epoch. */
                        const events = template.reduce( (accumulator, currentValue) => 
                            {
                            const { 
                                StartTime: st, 
                                FinishTime: ft, 
                                fkRotaTypeID: roteTypeID,
                                // rotaTemplateID is not being used and it is commented out for linting.
                                // fkRotaWeekTemplateID: rotaTemplateID,
                                pkRotaWeekTemplateEntryID: rotaWeekTemplateEntryID,
                                DayOfWeek: dow,
                                Colour: colour
                            } = currentValue

                            const day = '1970-01-' + (''+(4+dow)).padStart(2,0) + 'T'
                            const start = day + st
                            const end   = day + ft

                            /* this hard coding of colours will come out once 
                             * we have colours in the DB for templates. Or a
                             * general mapping of rota type to colour */
                            const rotaTypeName = rotaTypes.filter( rt => rt.RotaTypeID === roteTypeID )[0].Description

                            const newEvent = { title: rotaTypeName,
                                  start: start, 
                                  end: end, 
                                  id: rotaWeekTemplateEntryID,
                                  backgroundColor: '#' + colour,
                                  apiEvent: currentValue}

                            return [...accumulator, newEvent]
                            }
                        , [] )

                        return events
                    } ) } )
                .then( events => successCallback( events ) )
                .catch( err => failureCallback( err ) )
        }
    }
    
    
    
    const formatDay = d => {
        
        const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'][d.dow-1]
        return day
    }
    
    return (
        <>
        {showOverlay? (
            <TemplateCalendarOverlay api={api} selectInfo={showOverlay} 
                done={() => setShowOverlay(null)} appointmentTypes={appointmentTypes} /> 
            ): ''}
            
        <h1 className={'calHead'} >
            {'Template Calendar'}
            {templateName ? ` - ${templateName}` : ''}
        </h1>
         
        <FullCalendar
            plugins={[ resourceTimeGridPlugin, resourceDayGridPlugin, interactionPlugin ]}
            initialView='timeGridWeek'
            ref={calendarRef}
            businessHours= {{
                  // days of week. an array of zero-based day of week integers (0=Sunday)
                  daysOfWeek: [ 1, 2, 3, 4, 5, 6 ], // Monday - Saturday

                  startTime: dayStartTime,
                  endTime: '18:00', // an end time (6pm in this example)
            }} 
            initialDate={'1970-01-05'}
            visibleRange={{
                start:  '1970-01-05', 
                end:    '1970-01-09'
            }}
            selectable={true}
            selectMirror={true}
            hiddenDays={[ 0 ] /* hide */ }  
            slotDuration='00:30:00'
            slotMinTime='06:00:00'
            slotMaxTime='20:00:00'
            scrollTime='13:00:00'
            height= {'auto'}
            contentHeight={'auto'}
            dayHeaderContent={formatDay}
            events={eventSource}
            editable={true}
            eventResize={handleResize}
            eventClick={handleClick}
            eventContent={eventContent}
            eventDrop={eventDrop}
            select={handleSelectRegion}
            
            headerToolbar={{
                left: '',
                right: ''
            }}
            
            schedulerLicenseKey={schedulerLicenseKey}
          />
          </>
    )
}

// This component is not being used. It is commented out for linting.
// const DeleteConfirm = ({api, templateID, deleteTemplateEntryID, 
//                             setDeleteTemplateEntryID}) => {
    
//     const handleClick = e => {
        
//         e.preventDefault()
        
//         api.deleteRotaTemplateEntry(templateID, deleteTemplateEntryID)
//         .then(  response => setDeleteTemplateEntryID(0) )
//         .catch( err     =>  setDeleteTemplateEntryID(0) )
//     }
    
//     return (
//         <div style={{position: 'absolute', display: 'block', top: '50%', 
//             left: '50%',backgroundColor: 'white', zIndex: '100', padding: '2em', 
//             border: '3px solid var(--colour__primary)'}}  >
           
//             <div>Please confirm</div>
           
//            <button onClick={handleClick} >Delete</button><span> </span><span> </span>
//             <a href='.' onClick={e=>{e.preventDefault();setDeleteTemplateEntryID(0)}} >Cancel</a>
//         </div>
//     )
// }

export default TemplateCalendar


